import { ClassScheduleView } from "../schedule/ClassScheduleView";
import { preparatorySchedule } from "../schedule/data";

export const RaspisaniePodgotovka = () => <ClassScheduleView schedule={preparatorySchedule} />;
